import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'messages'
const verb = 'get'

export default class OspreyMessagesFromEmailList extends BaseAction {
    constructor(dataKey) {
        const id = '2a0e4acd-17dc-409d-8980-69b730b19a74'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getFromEmailList(contextOrn) {
        this.path = `/${resource}/from-addresses?ownerOrn=${contextOrn}`

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/messages/message-from-emailList.js